<script setup lang="ts">
import {
    Sheet,
    SheetContent,
    SheetHeader,
    SheetTitle,
} from '@/components/ui/sheet';
import useSheet from '@/composables/useSheet.ts';

const SheetTemplate = useSheet();
</script>

<template>
    <SheetTemplate v-slot="{ resolve, args: [props] }">
        <Sheet
            :default-open="true"
            @close="resolve"
            v-slot="{ close }"
        >
            <SheetContent
                class="gap-0"
                :class="props?.class"
            >
                <SheetHeader>
                    <SheetTitle>{{ props.title }}</SheetTitle>
                </SheetHeader>

                <div class="flex-1 overflow-y-auto p-4">
                    <div
                        v-if="
                            props?.content && typeof props.content === 'string'
                        "
                        v-html="props.content"
                        v-bind="{ close }"
                    />
                    <component
                        v-else-if="props.component"
                        :is="props.component"
                        v-bind="{
                            close,
                            ...props.props,
                        }"
                    />
                </div>
            </SheetContent>
        </Sheet>
    </SheetTemplate>
</template>
